/* eslint-disable no-underscore-dangle */
import Short from 'short-uuid';
import helper from '@/functions/helper';

import group from './group';
import nav from './nav';
import navFlat from './navFlat';
import org from './org';
import route from './route';

export default {
  state: {
    data: {},
    order: [],
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'PRODUCT',
      path: 'product',
      get: { active: true, msg: '' },
      update: { active: false, msg: 'Produkt aktualisiert.' },
      create: { active: false, msg: 'Produkt erstellt.' },
      duplicate: { active: false, msg: 'Produkt duplicated.' },
      delete: { active: false, msg: 'Produkt gelöscht.' },
      admin: {
        get: { active: true, msg: '' },
        update: { active: true, msg: 'Produkt aktualisiert.' },
        create: { active: true, msg: 'Produkt erstellt.', rtr: 'AllProducts' },
        duplicate: { active: true, msg: 'Produkt duplicated.' },
        delete: { active: true, msg: 'Produkt gelöscht.', rtr: 'AllProducts' },
      },
    },
  },
  getters: {
    dataById: (state) => (id) => state.data[id] ?? {},
  },
  mutations: {},
  actions: {
    SOCKET_PRODUCTS({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_PRODUCTS`, payload);
      dispatch('HANDLE_PAYLOAD', payload[1]);

      for (let i = 0; i < payload[1].length; i += 1) {
        const element = payload[1][i];

        dispatch('group/GET', { payload: element.id, multi: true });
        dispatch('nav/GET', { payload: element.id });
        dispatch('navFlat/GET', { payload: element.id });
        dispatch('org/GET', { payload: element.id, multi: true });
        dispatch('route/GET', { payload: element.id, multi: true });
      }

      // commit('SET_LOADING', false);
    },
    SOCKET_PRODUCT({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_PRODUCT`, payload);
      dispatch('HANDLE_PAYLOAD', payload[1]);

      dispatch('group/GET', { payload: payload[1].id, multi: true });
      dispatch('nav/GET', { payload: payload[1].id });
      dispatch('navFlat/GET', { payload: payload[1].id });
      dispatch('org/GET', { payload: payload[1].id, multi: true });
      dispatch('route/GET', { payload: payload[1].id, multi: true });

      // commit('SET_LOADING', false);
    },
    DUPLICATE({ commit, getters }, payload) {
      if (!getters.config.duplicate.active) return;

      commit('CLEAR_ERROR');

      const rid = Short.uuid();
      commit('ADD_QUEUE', { rid, payload: { ...getters.config.duplicate } });
      this._vm.$socket.client.emit('PRODUCT_DUPLICATE', rid, { ...helper.nullify(payload) });
      commit('SET_LOADING', true);
    },
  },
  modules: {
    group: { ...group, namespaced: true },
    nav: { ...nav, namespaced: true },
    navFlat: { ...navFlat, namespaced: true },
    org: { ...org, namespaced: true },
    route: { ...route, namespaced: true },
  },
};
